import { Suspense } from "react"

import { useRepositoryMetaTitle } from "../app/routing"
import { DocumentListHeader } from "../documents/DocumentListHeader/DocumentListHeader"
import { DocumentListLayout } from "../documents/documentListLayout"
import { DocumentListSearchParamsProvider } from "../documents/DocumentListSearchParamsProvider"
import { OnboardingSideMenu } from "./OnboardingSideMenu"
import { OnboardingSteps, OnboardingStepsSkeleton } from "./OnboardingSteps"

export function OnboardingPage() {
  useRepositoryMetaTitle("Onboarding")

  return (
    <DocumentListSearchParamsProvider>
      <DocumentListLayout
        header={<DocumentListHeader tab={undefined} />}
        body={
          <Suspense fallback={<OnboardingStepsSkeleton />}>
            <OnboardingSteps />
          </Suspense>
        }
        sidePanel={
          <Suspense>
            <OnboardingSideMenu />
          </Suspense>
        }
      />
    </DocumentListSearchParamsProvider>
  )
}
